let lockCount = 0;
let restorePage: (() => void) | undefined;

export function lockPageScroll(): () => void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return () => {};

  if (lockCount === 0) {
    const root = document.documentElement;
    const body = document.body;
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
    const scrollbarWidth = Math.max(0, window.innerWidth - root.clientWidth);
    const properties = ['position', 'top', 'left', 'right', 'overflow', 'padding-right'] as const;
    const bodyStyles = properties.map(
      (property) =>
        [
          property,
          body.style.getPropertyValue(property),
          body.style.getPropertyPriority(property),
        ] as const
    );
    const rootOverflow = root.style.getPropertyValue('overflow');
    const rootOverflowPriority = root.style.getPropertyPriority('overflow');
    const rootScrollBehavior = root.style.getPropertyValue('scroll-behavior');
    const rootScrollBehaviorPriority = root.style.getPropertyPriority('scroll-behavior');
    const paddingRight = parseFloat(window.getComputedStyle(body).paddingRight) || 0;

    // фиксация body также предотвращает прокрутку фона жестами в ios/safari
    root.style.setProperty('overflow', 'hidden');
    body.style.setProperty('position', 'fixed');
    body.style.setProperty('top', `${-scrollY}px`);
    body.style.setProperty('left', `${-scrollX}px`);
    body.style.setProperty('right', `${scrollX}px`);
    body.style.setProperty('overflow', 'hidden');
    if (scrollbarWidth > 0) {
      body.style.setProperty('padding-right', `${paddingRight + scrollbarWidth}px`);
    }

    restorePage = () => {
      for (const [property, value, priority] of bodyStyles) {
        body.style.setProperty(property, value, priority);
      }
      root.style.setProperty('overflow', rootOverflow, rootOverflowPriority);
      root.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo({ left: scrollX, top: scrollY, behavior: 'instant' });
      root.style.setProperty('scroll-behavior', rootScrollBehavior, rootScrollBehaviorPriority);
    };
  }

  lockCount++;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    if (--lockCount === 0) {
      restorePage?.();
      restorePage = undefined;
    }
  };
}
